import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'seal-annual-report',
    templateUrl: './seal-annual-report.component.html',
    styleUrls: ['./seal-annual-report.component.scss'],
})
export class SealAnnualReportComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
